//
// revenue = revenue via outgoing invoice
// expense = expense via incoming invoice
//

import { z } from '@/utils/zod'

export const baseReceiptTypes = ['expense', 'revenue'] as const

export const BaseReceiptTypeSchema = z.enum(baseReceiptTypes)

export type ReceiptBaseType = z.infer<typeof BaseReceiptTypeSchema>

//
// donation = revenue via outgoing donation (equals type revenue)
// invoice = revenue via outgoing invoice (equals type revenue)
// deposit = revenue via outgoing invoice for a prepayment (equals type depositRevenue)
// offer = a non-binding offer
// confirmation = confirmation of an accepted offer
//

export const advancedReceiptTypesWithoutInvoice = ['deposit', 'donation', 'offer', 'confirmation'] as const

export const advancedReceiptTypes = ['invoice', ...advancedReceiptTypesWithoutInvoice] as const

export const AdvancedReceiptTypeSchema = z.enum(advancedReceiptTypes)

export type AdvancedReceiptType = z.infer<typeof AdvancedReceiptTypeSchema>

export const receiptTypes = [...baseReceiptTypes, ...advancedReceiptTypes] as const

export const isReceiptType = (identifier: string): identifier is ReceiptType => {
    return receiptTypes.includes(identifier as ReceiptType)
}

export const ReceiptTypeSchema = z.enum(receiptTypes)

export type ReceiptType = z.infer<typeof ReceiptTypeSchema>

//
// Invoice type + offset status
//

export const invoiceTypes = ['invoice', 'invoiceMembershipFee', 'invoiceBooking'] as const

export const ReceiptInvoiceTypeSchema = z.enum(invoiceTypes)

export type ReceiptInvoiceType = z.infer<typeof ReceiptInvoiceTypeSchema>

export const ReceiptOfferStatusSchema = z.enum(['open', 'accepted', 'rejected'])

export type ReceiptOfferStatus = z.infer<typeof ReceiptOfferStatusSchema>

export const ReceiptOrderConfirmationStatusSchema = z.enum(['open', 'finished'])

export type ReceiptOrderConfirmationStatus = z.infer<typeof ReceiptOrderConfirmationStatusSchema>
